export class PageInfo {
  pageName: string;
  language: string;

  constructor(pageName: string, language: string) {
    this.pageName = pageName;
    this.language = language;
  }

  public getPageName(): string {
    return this.pageName;
  }

  public getLanguage(): string {
    return this.language;
  }

  public getReferringURL(): string {
    return '';
  }
}
